export enum OFFER_GROUPING {
  BONUS_SECTION = 'bonusSection'
}
